function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("clipPath", {
  id: "a"
}, React.createElement("path", {
  d: "M11 11L4.7 21.7h12.4L23.4 11z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("linearGradient", {
  id: "b",
  gradientTransform: "scale(14.9601 -14.9601) rotate(59.092 23.136 6.698)",
  gradientUnits: "userSpaceOnUse",
  x1: 4.75,
  x2: 5.75,
  y1: 21.74,
  y2: 21.74
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#ffb800"
}), React.createElement("stop", {
  offset: 0.617,
  stopColor: "#ca7334"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#ca7334"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  clipPath: "url(#a)",
  d: "M0 18.9L9.7 2.8l18.4 11L18.5 30z",
  fill: "url(#b)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.7 0l12.4 21.7L23.4 11 17.2 0z",
  fill: "#ffb800"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    height: 30,
    viewBox: "0 0 28.1 30",
    width: 28.1,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.9cc6604a.svg";
export { ForwardRef as ReactComponent };